/* @ngInject */

export default (AssetFinanceProposalAssociatedFeeType) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function AssetFinanceProposalAssociatedFee(id, feeType, name, amountWithGst, isCapitalised) {
    this.id = id;
    this.feeType = feeType;
    this.name = name;
    this.amountWithGst = amountWithGst;
    this.isCapitalised = isCapitalised;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceProposalAssociatedFee.Blank = function (feeType) {
    return AssetFinanceProposalAssociatedFee.Build({
      id: _.uuid(),
      feeType: AssetFinanceProposalAssociatedFeeType.Build(feeType),
      name: '',
      amountWithGst: 0,
      isCapitalised: false
    });
  };

  AssetFinanceProposalAssociatedFee.Build = function (data) {
    return new AssetFinanceProposalAssociatedFee(
      data.id,
      AssetFinanceProposalAssociatedFeeType.Build(data.feeType),
      data.name,
      data.amountWithGst,
      data.isCapitalised
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceProposalAssociatedFee.prototype.getName = function () {
    return this.name;
  };

  return AssetFinanceProposalAssociatedFee;
};
